"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  number: "+1.2%",
  label: "Monthly Yield",
  description: "The aggregate index showed resilient growth across core urban sectors despite seasonal shifts."
}, {
  number: "0.85",
  label: "Volatility Score",
  description: "Market stability remains within the target corridor, indicating low risk for institutional entry."
}, {
  number: "14.2k",
  label: "Active Listings",
  description: "Inventory levels have stabilized, providing a balanced environment for price discovery."
}, {
  number: "4.8%",
  label: "Annual Forecast",
  description: "Projected growth remains robust based on current velocity and macroeconomic indicators."
}];
export default function TheStrategicContext() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="253684" id="monthly-movement-commentary" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 z-0 opacity-5 pointer-events-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1664816/img/market_data_grid.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1664816/img/market_data_grid.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1664816/img/market_data_grid.png-wvc-sizes" alt="Market data visualization background" className="w-full h-full object-cover" loading="lazy" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        {}
        <div ref={headerRef} className={`flex justify-center mb-20 md:mb-32 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-[60px] leading-tight font-default font-bold text-center max-w-4xl text-primary">
            Monthly Movement Commentary
          </h2>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col p-8 lg:p-10 border-b border-border md:border-r md:nth-[2n]:border-r-0 lg:border-b-0 lg:border-r lg:last:border-r-0 bg-card/50 backdrop-blur-sm">
              <div className="text-[72px] font-bold font-mono leading-none mb-6 text-primary tracking-tighter">
                {stat.number}
              </div>
              <div className="text-[14px] uppercase tracking-widest mb-4 text-muted-foreground font-mono font-semibold">
                {stat.label}
              </div>
              <p className="text-[18px] text-muted-foreground font-default leading-relaxed">
                {stat.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}